var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pending",
    clipPath: "url(#clip0_1232_24467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sandglass_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 2.66536C3.33301 2.31174 3.47348 1.9726 3.72353 1.72256C3.97358 1.47251 4.31272 1.33203 4.66634 1.33203H11.333C11.6866 1.33203 12.0258 1.47251 12.2758 1.72256C12.5259 1.9726 12.6663 2.31174 12.6663 2.66536V3.90536C12.6663 4.45413 12.5307 4.99438 12.2717 5.47818C12.0127 5.96198 11.6383 6.37435 11.1817 6.6787L9.20167 7.9987L11.1817 9.3187C11.6383 9.62304 12.0127 10.0354 12.2717 10.5192C12.5307 11.003 12.6663 11.5433 12.6663 12.092V13.332C12.6663 13.6857 12.5259 14.0248 12.2758 14.2748C12.0258 14.5249 11.6866 14.6654 11.333 14.6654H4.66634C4.31272 14.6654 3.97358 14.5249 3.72353 14.2748C3.47348 14.0248 3.33301 13.6857 3.33301 13.332V12.092C3.333 11.5433 3.46844 11.0031 3.72732 10.5193C3.98619 10.0355 4.3605 9.62312 4.81701 9.3187L6.79834 7.9987L4.81834 6.6787C4.36158 6.37443 3.98702 5.96209 3.72791 5.47829C3.46879 4.99448 3.33315 4.45419 3.33301 3.90536V2.66536Z",
    fill: "#FFF089"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_24467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.2bf5ec433045b4cd9fa9284b71020800.svg";
export { ForwardRef as ReactComponent };